import { envConfigs } from '@config/envConfigs';
import { IItemResponse, IPagedResultsV1 } from '@gcl/react-core';
import { apiServerGet, apiServerPost, apiServerPut } from '@common/axios.services';
import { ICreateMyGemsRequest, IGetMyGemsRequest, IMyGems, IUpdateMyGemsRequest } from './myGems.models';

export const apiRoutes = {
  myGems: '/MyGems',
  myGemsWithId: (id: number) => `/MyGems/${id}`,
};

export const getMyGemsAsync = async (props: IGetMyGemsRequest): Promise<IPagedResultsV1<IMyGems>> => {
  const result = await apiServerGet<IPagedResultsV1<IMyGems>>(`${envConfigs.apiBaseUrl}${apiRoutes.myGems}`, {
    params: props,
  });
  return result.data;
};

export const postMyGemsAsync = async (request: ICreateMyGemsRequest): Promise<IItemResponse<IMyGems>> => {
  const result = await apiServerPost<IItemResponse<IMyGems>>(`${envConfigs.apiBaseUrl}${apiRoutes.myGems}`, request);
  return result.data;
};
export const putMyGemsAsync = async (id: number, request: IUpdateMyGemsRequest): Promise<IItemResponse<IMyGems>> => {
  const result = await apiServerPut<IItemResponse<IMyGems>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.myGemsWithId(id)}`,
    request,
  );
  return result.data;
};
